/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Classification_PriceInputs */

const vi_product_classification_price = /** @type {(inputs: Product_Classification_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn giá`)
};

/**

* @param {Product_Classification_PriceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_classification_price = /** @type {((inputs?: Product_Classification_PriceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Classification_PriceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_classification_price(inputs)
});